<template>
    <v-container fluid pa-0 dark flat my-5>
        <v-layout justify-center>
            <div>
                <h1 style="text-align: center;">{{ encabezado }}</h1>
                <div style="text-align: center;">
                    <p>{{ mensajeGracias }}</p>
                    <p>{{ mensaje }}</p>
                    <p>{{ mensaje2 }}</p>
                    <p>{{ mensaje3 }}</p>
                </div>
            </div>
        </v-layout>
    </v-container>
</template>
<script>
    import * as firebase from 'firebase/app'
	import 'firebase/firestore'
	import cryptoJS from 'crypto-js'
	import axios from 'axios'
    import * as moment from 'moment'

    export default {
        name: 'Solicitud',
	    filters: {
            dateFromTimestamp: function(timestamp) {
                let formattedDate = ''
                if (timestamp.seconds) {
                    formattedDate = timestamp.toDate().toLocaleString()
                } else {
                    formattedDate = new Date(timestamp).toLocaleString()
                }
                return formattedDate
            }
	  },
      data() {
          return {
              pedido: {},
              mensaje: '',
              mensajeGracias: '',
              encabezado: '',
              mensaje2: '',
              mensaje3: ''
          }
      },
      methods: {
          toThousandFilter(num) {
                return (+num || 0).toString().replace(/^-?\d+/g, m => m.replace(/(?=(?!\b)(\d{3})+$)/g, '.'))
            },
          async get_pedido(id,respuesta) {
                const db = firebase.firestore()
                const here = this
                await db.collection('fletes_dev').doc(id).get().then(function(doc) {
                    const datos = doc.data()
                    if (datos !== undefined) {
                        if (!datos.respuestaConvenio) {
                            // data === 0 es cancelar, data === 1 es aceptar
                            // verificar si el pedido ya pasó por este proceso
                            datos.id = doc.id
                            if (respuesta == 1) {
                                datos.id_pedido = doc.id
                                here.encabezado = 'ACEPTADO'
                                const fechaSplit = datos.fecha.split('-')
                                const fecha = fechaSplit[2] + '/' + fechaSplit[1] + '/' + fechaSplit[0]
                                here.mensajeGracias = 'Gracias ' + datos.usuario.nombre
                                here.mensaje = 'El servicio fue agendado con éxito para el día ' + fecha + ' a las ' + datos.hora
                                here.mensaje2 = 'Ha sido reflejado en su cuenta corriente por un valor de $' + here.toThousandFilter(datos.valorBase) + ' IVA Incluido.'
                                here.mensaje3 = 'Gracias por confiar en nosotros.'
                                here.accepted(datos)
                            } else if ( respuesta == 0){
                                here.encabezado = 'RECHAZADO'
                                here.mensaje = 'De acuerdo a sus instrucciones hemos anulado el servicio.'
                                here.mensaje2 = 'Muchas Gracias'
                                here.rejected(datos)
                            }
                        } else {
                            here.encabezado = 'Ya hemos registrado tu preferencia'
                            here.mensaje2 = 'Muchas Gracias'
                        }
                        
                    } else {
                        here.mensaje = 'Pedido Inexistente.'
                    }
                })
                // console.log('Respuesta convenio: ' + respuesta)
          },
          async accepted(datos) {
                const db = firebase.firestore()
                const here = this
                //cargar a cuenta corriente
                let cliente = {}
                await db.collection('users').doc(datos.clienteID).get().then(function(doc){
                    const data = doc.data()
                    cliente = data
                })
                // console.log(cliente)
                const cargoCuentaCorriente = {
                    cuentaCorriente: {
                        montoMaximo: cliente.cuentaCorriente.montoMaximo,
                        usado: datos.valorBase + cliente.cuentaCorriente.usado
                    }
                }
                db.collection('users').doc(datos.clienteID).update(cargoCuentaCorriente)
                // cambiar datos en convenio
                const data = {
                    estado: 'Registrado',
                    respuestaConvenio: true,
                    fecha_respuesta_convenio: firebase.firestore.Timestamp.fromDate(new Date())
                }
                db.collection('fletes_dev').doc(datos.id).update(data)
              //cambiar agenda (onHold)
                await db.collection("vehiculos").doc(datos.transportista.id).collection('agenda').doc(datos.transportista.agenda).update({ onHold: false })
              // enviar correos
                const dataPedido = datos
                const dataCliente = {
                    tipoCliente: cliente.tipoCliente,
                    razonSocial: cliente.razonSocial
                }
                let conductor = {}
                await db.collection('conductores').doc(datos.transportista.conductor).get().then(function(doc) {
                    conductor = doc.data()
                })
                // dejar registro de la aceptacion del cliente
                const registro = {
                    Fecha_Registro: firebase.firestore.Timestamp.fromDate(new Date()),
                    valorBase: datos.valorBase,
                    usuarioSistema: datos.usuario.email,
                    activo: false,
                    registro: 'Cliente acepta convenio'
                }
                var addRegistro = db.collection('fletes_dev').doc(datos.id)
                await addRegistro.update({
                    registroCambios: firebase.firestore.FieldValue.arrayUnion(registro)
                })
                dataPedido.id = datos.id
                dataPedido.documento = 'fletes_dev'
                const updateAndGetValoresPedido = firebase.functions().httpsCallable('updateAndGetValoresPedido')
                const valores = await updateAndGetValoresPedido(dataPedido)
                const detalleCalculosValores = valores.data
                console.log(detalleCalculosValores)
                dataPedido.origen = {
                    direccion: datos.direcciones.origen
                }
                dataPedido.destino = {
                    direccion: datos.direcciones.destino
                }
                dataPedido.cliente = {
                    nombre: cliente.nombre,
                    tipoCliente: cliente.tipoCliente,
                    razonSocial: cliente.razonSocial
                }
                dataPedido.telefono = cliente.telefono
                /* dataPedido.cliente.nombre = cliente.nombre
                dataPedido.cliente.tipoCliente = cliente.tipoCliente // ok
                dataPedido.cliente.razonSocial = cliente.razonSocial */
                dataPedido.type = 'f'
                dataPedido.idTransporte = datos.transportista.id
                dataPedido.emailTransporte = conductor.datos.email // ok
                dataPedido.conductor = conductor.datos.nombres + ' ' + conductor.datos.apellidos // ok
                dataPedido.precioNeto = here.toThousandFilter(detalleCalculosValores.neto)
                dataPedido.ventaTotalTransportista = '$' + here.toThousandFilter(detalleCalculosValores.ventaTotalTransportista) // ok
                dataPedido.comision = detalleCalculosValores.comision // ok
                dataPedido.comisionTransportista = '$' + here.toThousandFilter(detalleCalculosValores.netoTransportista)
                dataPedido.fechaServicio = moment(datos.fecha_servicio_obj).format('dddd, DD/MM/YY')
                console.log(dataPedido)
                const enviaCorreo = firebase.functions().httpsCallable('cargoCuentaCorriente')
                await enviaCorreo(dataPedido)
                .then(({ data }) => {
                    console.log('Transaccion')
                    console.log('Antes del descuento')
                })
                .catch(httpsError => {
                    console.log('error: ', httpsError)
                })
          },
          async rejected(datos) {
                const db = firebase.firestore()
                const here = this
                // limpiar agenda de transportista
                db.collection('vehiculos').doc(datos.transportista.id).collection('agenda').doc(datos.transportista.agenda).delete().then(function(){
                    console.log('Agenda eliminada')
                })
                // eliminar transportista de pedido
                const eliminaTransportista = db.collection('fletes_dev').doc(datos.id)
                let removeTransportista = eliminaTransportista.update({
                    transportista: firebase.firestore.FieldValue.delete()
                })
                // dejar registro del rechazo del cliente
                const registro = {
                    Fecha_Registro: firebase.firestore.Timestamp.fromDate(new Date()),
                    valorBase: datos.valorBase,
                    usuarioSistema: datos.usuario.email,
                    activo: false,
                    registro: 'Cliente Rechaza convenio'
                }
                var addRegistro = db.collection('fletes_dev').doc(datos.id)
                await addRegistro.update({
                    registroCambios: firebase.firestore.FieldValue.arrayUnion(registro)
                })
                // correo a admin avisando que cliente rechazó el servicio
                let cliente = {}
                await db.collection('users').doc(datos.clienteID).get().then(function(doc){
                    const data = doc.data()
                    cliente = data
                })
                datos.razonSocial = cliente.razonSocial
                datos.correoConvenioRechazado = true
                const enviaCorreo = firebase.functions().httpsCallable('cargoCuentaCorriente')
                await enviaCorreo(datos)
                .then(({ data }) => {
                    console.log('Transaccion')
                    console.log('Antes del descuento')
                })
                .catch(httpsError => {
                    console.log('error: ', httpsError)
                })
                // cambiar estado a "No aceptado por cliente"
                const dataConvenio = {
                        estado: 'No aceptado por cliente',
                        respuestaConvenio: true
                    }
                db.collection('fletes_dev').doc(datos.id).update(dataConvenio)
          },
          async sendEmail(datos) {

          }

      },
      mounted() {
            if(this.$route.query.id){ 
                this.get_pedido(this.$route.query.id, this.$route.query.data)
            } else {
                console.log('no hay pedido identificado')
            }
      }
    }
</script>